import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import CatalogForm from "./CatalogForm"
import {DetailType} from "../dataCatalogTypes"
import { useNavModel } from "../../../../model/navModel";
const CataLogAdd = () => {
    const history:any = useHistory();
    const { addNav, closeNav,getSelectedNavState } = useNavModel()
    return (
        <CatalogForm/>
    )
}
export default CataLogAdd